if (!customElements.get('accordion-group')) {
  class AccordionGroup extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      this.accordions = this.querySelectorAll('.js-accordion');

      this.accordions.forEach((accordion) => {
        accordion.addEventListener('toggle', (e) => {
          if (!e.target.open) return;

          this.toggleAccordions(e.target);
        });
      })
    }

    toggleAccordions(target) {
      this.accordions.forEach((accordion) => {
        accordion.open = accordion === target;
      })
    }
  }

  customElements.define('accordion-group', AccordionGroup);
}
